import { z } from 'zod';
export const getUserOktaStatusRequestParamsSchema = z.object({
    accountId: z.string(),
});
export const getUserOktaStatusResponseSchema = z.union([
    z.enum(['ACTIVE', 'DEPROVISIONED', 'LOCKED_OUT', 'PASSWORD_EXPIRED', 'PROVISIONED', 'RECOVERY', 'STAGED', 'SUSPENDED', 'SDK_UNKNOWN']),
    z.object({ message: z.string() }),
    z.object({ error: z.string() }),
    z.instanceof(Error),
]);
